import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { RocketLaunch } from '@mui/icons-material';
import { styled_tariff_icons } from 'shared/components/fields/icon/icons/tariff-icons/dark-light-Icon';
import { web_element_icons } from 'shared/components/fields/icon/icons';
import { UserIcons } from 'shared/components/icon/icon.user_icons_panel/users-icons';
import { TabsPanelWithScroll, } from 'shared/components/tab/layout/tab-panel-with-scroll';
import { useBuyDesignPackage, useDesignPackage } from 'shared/hooks/helpers';
import { IconPanelSelectDevice } from 'shared/components/fields/icon/icon-panel_select_device ';
import { IconPanelSettingsAccount } from 'features/account.settings/ui/icon-settings/icon-panel_settings_account';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { custom_tab_icons as custom_tab_icons_config } from '../../../shared/components/fields/icon/icons/tab-icons';
export const IconTab = memo(function IconTab(props) {
    const { title, onChangeIcon, showTitleIcon, showButtonDelete, customTab } = props;
    const allow_design_package = useDesignPackage();
    const BuyDesignPackage = useBuyDesignPackage(close);
    const is_demo = useAppSelector((state) => state.account.is_demo);
    const freeArray = useMemo(() => web_element_icons.filter((Icon) => !Icon.paid), []);
    const tariffArray = useMemo(() => web_element_icons.filter((Icon) => Icon.paid && Icon.styled === undefined), []);
    const iconForCustomTab = useMemo(() => [
        {
            component: custom_tab_icons_config,
            title: '',
            style: {
                textTransform: 'none',
                padding: '0',
            },
            props: {},
        },
    ], []);
    const defaultArrIcon = useMemo(() => [
        {
            component: freeArray,
            title: 'Базовый',
            style: {
                textTransform: 'none',
                padding: '0',
            },
        },
        {
            component: onChangeIcon
                ? allow_design_package || is_demo
                    ? tariffArray
                    : null
                : tariffArray,
            title: 'Расширенный',
            style: {
                '.MuiTab-iconWrapper': { mr: '0px' },
                textTransform: 'none',
                padding: '0',
                overflow: 'visible',
            },
            props: {
                icon: _jsx(RocketLaunch, { color: "primary" }),
                iconPosition: 'start',
            },
        },
        {
            component: onChangeIcon
                ? allow_design_package || is_demo
                    ? styled_tariff_icons
                    : null
                : styled_tariff_icons,
            title: 'Styled',
            style: {
                '.MuiTab-iconWrapper': { mr: '0px' },
                textTransform: 'none',
                padding: '0',
                fontStyle: 'italic',
                flexWrap: 'wrap',
            },
            props: {
                icon: _jsx(RocketLaunch, { color: "primary" }),
                iconPosition: 'start',
            },
        },
    ], []);
    const dataForArrElement = useMemo(() => (customTab ? iconForCustomTab : defaultArrIcon), [customTab]);
    const arrForElement = dataForArrElement.map((el) => {
        const regexNotSimilar = useMemo(() => new RegExp(`[А-Яа-я]$`), []);
        const filterArrayNotSimilar = useMemo(() => el.component?.filter((Icon) => regexNotSimilar.test(Icon.title)) ?? null, [dataForArrElement]);
        return {
            component: el.component ? (onChangeIcon ? (_jsx(IconPanelSelectDevice, { filterArrayNotSimilar: filterArrayNotSimilar, onChangeIcon: onChangeIcon, customTab: customTab })) : (_jsx(IconPanelSettingsAccount, { filterArrayNotSimilar: filterArrayNotSimilar, array: el.component }))) : (BuyDesignPackage),
            style: el?.style,
            props: el?.props,
            title: el.title,
        };
    });
    const zont_all_icons = useMemo(() => [
        ...arrForElement,
        {
            component: allow_design_package ? (_jsx(UserIcons, { showTitleIcon: showTitleIcon, showButtonDelete: showButtonDelete, onChangeIcon: onChangeIcon })) : (BuyDesignPackage),
            title: 'Загруженные',
            style: {
                textTransform: 'none',
                padding: '0',
            },
        },
    ], []);
    return (_jsx(TabsPanelWithScroll, { arrayPanel: customTab ? arrForElement : zont_all_icons, title: title }));
});
